import { assertCanHandle, isNil } from '@lucidlink/tscore';
import { createTextDecoder } from '#common/util';
import { AuthorizationError, PresignedUrlError } from '#object-store/types';
import { BasePointerKind, DataStoreInvalidCredentialsError, DataStoreInvalidTypeError, DataStoreKind, DataStoreNotFoundError, DataStoresError, } from './types';
export class RekeyValidator {
    dataStores;
    fileNodeManager;
    kvHelperWasm;
    commonConfigKeyHelper;
    presignedUrLHelper;
    decoder = createTextDecoder();
    constructor(dataStores, fileNodeManager, kvHelperWasm, commonConfigKeyHelper, presignedUrLHelper) {
        this.dataStores = dataStores;
        this.fileNodeManager = fileNodeManager;
        this.kvHelperWasm = kvHelperWasm;
        this.commonConfigKeyHelper = commonConfigKeyHelper;
        this.presignedUrLHelper = presignedUrLHelper;
    }
    async validateRekey(name, accessKey, hubEncryptedSecretKey, adminEncryptedSecretKey) {
        const dataStore = await this.dataStores.get(name);
        if (isNil(dataStore)) {
            throw new DataStoreNotFoundError(`Data store does not exist: ${name}`);
        }
        if (dataStore.kind !== DataStoreKind.S3) {
            throw new DataStoreInvalidTypeError(`Data store '${name}' must be an S3 data store, got: ${dataStore.kind}`);
        }
        const entryKey = await this.getExternalFileFor(name);
        if (isNil(entryKey)) {
            return;
        }
        const dataStoreWithNewCredentials = {
            ...dataStore,
            accessKey,
            hubEncryptedSecretKey,
            adminEncryptedSecretKey,
        };
        await this.validateWithFile(dataStoreWithNewCredentials, entryKey);
    }
    async validateWithFile(dataStore, entry) {
        const layoutKvs = await this.fileNodeManager.getLayoutKeyRange(entry.inodeId);
        const basePointer = this.kvHelperWasm.parseBasePointer(layoutKvs);
        if (basePointer.kind !== BasePointerKind.SINGLE_OBJECT) {
            throw new DataStoresError(`Invalid base pointer kind: ${basePointer.kind}`);
        }
        const url = await this.commonConfigKeyHelper.decryptCommon(basePointer.encryptedObjectId, basePointer.iv);
        try {
            await this.presignedUrLHelper.generatePresignedUrl(this.decoder.decode(url), dataStore);
        }
        catch (err) {
            assertCanHandle(err, (e) => e instanceof PresignedUrlError || e instanceof AuthorizationError);
            throw new DataStoreInvalidCredentialsError(`Failed to validate credentials: ${err.message}`);
        }
    }
    async getExternalFileFor(dataStoreName) {
        const result = await this.dataStores.listExternalFilesPaginated(dataStoreName, { limit: 1 });
        const entries = result.items;
        if (entries.length === 0) {
            return undefined;
        }
        return entries[0];
    }
}
